import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { IsNoNeedCompareChar } from "../../utils/Helper";
import SimpleSentence from "./SimpleSentence";

/**
 * The XunFei ASR result use levenshtein, can show the insert/delete/modify
 *  this component can just render the levenshtein-toolbox result as we want
 *
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const LDResultRender = (props) => {
    const { nodes, showRealAnswer, language } = props;
    return (
        // <Text {...props}>
        //     {nodes.map((node, i) => (
        //         <LDResultRenderWord key={i} node={node} showRealAnswer={showRealAnswer} style={props.subTextStyle} />
        //     ))}
        // </Text>
        nodes.map((node, i) => <LDResultRenderWord key={i} language={language} node={node} showRealAnswer={showRealAnswer} style={props.style} />)
    );
};

LDResultRender.propTypes = {
    nodes: PropTypes.array,
    language: PropTypes.string,
    showRealAnswer: PropTypes.bool,
    subTextStyle: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
};

const LDResultRenderWord = (props) => {
    const { node, showRealAnswer, language } = props;
    switch (node.op) {
        // match operation was done
        case "M":
            //如果拼音相同，汉字不同，将语音评测结果校正为原文汉字
            return (
                <SimpleSentence {...props} style={[props.style, !IsNoNeedCompareChar(node.letter) ? styles.asrMatchedWord : {}]}>
                    {node.from}
                </SimpleSentence>
            );
        // subtitution operation was done
        case "S":
            //node from -> to
            //from is the reference text, to is the real answer, for now we show from, but you can set
            return (
                <SimpleSentence {...props} style={[props.style, !IsNoNeedCompareChar(node.from) || !IsNoNeedCompareChar(node.to) ? styles.asrModifiedWord : {}]}>
                    {showRealAnswer ? node.to : node.from}
                </SimpleSentence>
            );
        // insert operation was done
        case "I":
            //NOTE, we add () for this case
            return (
                <SimpleSentence {...props} style={[props.style, !IsNoNeedCompareChar(node.letter) ? styles.asrInsertedWord : {}]}>
                    ({node.letter})
                </SimpleSentence>
            );
        // delete operation was done
        case "D":
            return (
                <SimpleSentence {...props} style={[props.style, !IsNoNeedCompareChar(node.letter) ? styles.asrDeletedWord : {}]}>
                    {language === "en" ? <Fragment>&nbsp;&nbsp;</Fragment> : <Fragment>&nbsp;&nbsp;&nbsp;&nbsp;</Fragment>}
                </SimpleSentence>
            );
        default:
            return null;
    }
};
LDResultRenderWord.propTypes = {
    node: PropTypes.object,
    language: PropTypes.string,
    showRealAnswer: PropTypes.bool,
};

const styles = {
    asrMatchedWord: {
        color: "#0044fe",
    },
    asrInsertedWord: {
        color: "#ff8900",
    },
    asrDeletedWord: {
        color: "#e53935",
        textDecorationLine: "underline",
    },
    asrModifiedWord: {
        color: "#ff4b4c",
    },
};

export default LDResultRender;
